"use strict";

import React from 'react';
import PropTypes from 'prop-types';
import shallowCompare from 'react-addons-shallow-compare';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Collection from '../../types/Collection';
import Spinner from '../ui/Spinner2.react';
import CollectionTile from './CollectionTile.react';
import MediaItemTileBubble from './MediaItemTileBubble.react';

/**
 * CollectionGallery component
 */
export default class CollectionGallery extends React.Component {
    /**
     * React: propTypes
     */
    static propTypes = {
        title: PropTypes.string,
        collections: ImmutablePropTypes.mapOf(PropTypes.instanceOf(Collection)),
        mediaLoading: PropTypes.bool,
        tileType: PropTypes.oneOf(['poster', 'poster-bubble', 'backdrop', 'backdrop-progress-bar', 'backdrop-detailed']),
        collapsibleTiles: PropTypes.bool,
        highlighted: PropTypes.bool,
        className: PropTypes.string
    };

    /**
     * React: defaultProps
     */
    static defaultProps = {
        title: '',
        media: null,
        mediaLoading: false,
        tileType: 'poster-bubble',
        collapsibleTiles: false,
        highlighted: false
    };

    /**
     * React: state
     */
    state = {
        shouldTileBubbleBeVisible: false,
        tileBubbleMediaItem: null,
        tileBubbleMediaItemTileNode: null
    };

    /**
     * React: UNSAFE_componentWillReceiveProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.collections && nextProps.collections !== this.props.collections && this.state.tileBubbleMediaItem) {
            this.setState({
                tileBubbleMediaItem: nextProps.collections.get(this.state.tileBubbleMediaItem.id)
            });
        } else if (!nextProps.media) {
            this.setState({
                tileBubbleMediaItem: null,
                shouldTileBubbleBeVisible: false
            });
        }
    }

    /**
     * React: shouldComponentUpdate
     */
    shouldComponentUpdate(nextProps, nextState) {
        return shallowCompare(this, nextProps, nextState);
    }

    /**
     * React: render
     */
    render() {
        var media = [];
        if (this.props.collections && this.props.collections.size > 0) {
            this.props.collections.forEach((collection, key) => {
                media.push(
                    <CollectionTile key={key}
                                        collection={collection}
                                        tileType={this.props.tileType}
                                        toggleTileBubble={this._toggleTileBubble}
                                        collapsible={this.props.collapsibleTiles}/>
                );
            });

            // show loading tile set instead
        } else {
            for (let index = 0; index <= 5; index++) {
                media.push(<CollectionTile key={index} tileType={this.props.tileType}/>);
            }
        }

        var className = 'collection-gallery'
            + (this.props.collapsibleTiles ? ' collapsible-tiles' : '')
            + (this.props.highlighted ? ' highlighted' : '')
            + (this.props.className ? ' ' + this.props.className : '');

        return (
            <div className={className}>
                <div className="container">
                    {this.props.title ? (
                        <div className="row">
                            <div className="col-xs-12 header">
                                <h2>{this.props.title}</h2>
                            </div>
                        </div>
                    ) : null}

                    <div className="row">
                        <div className="movies-container">
                            {media}
                        </div>
                        {this.props.tileType === 'poster-bubble' ? (
                            <MediaItemTileBubble shouldTileBubbleBeVisible={this.state.shouldTileBubbleBeVisible}
                                                 mediaItem={this.state.tileBubbleMediaItem}
                                                 tileNode={this.state.tileBubbleMediaItemTileNode}/>
                        ) : null}
                    </div>
                </div>
                {this.props.mediaLoading && this.props.collections && this.props.collections.size > 0 ? (
                    <div className="media-loading">
                        <Spinner />
                    </div>
                ) : null}
            </div>
        );
    }

    /**
     * Toggle tile bubble
     *
     * @param shouldBeVisible
     * @param mediaItem
     * @param tileNode
     * @private
     */
    _toggleTileBubble = (shouldBeVisible, mediaItem = null, tileNode = null) => {
        // return if tile type does not supports bubble
        if (this.props.tileType !== 'poster-bubble') return;

        this.setState({
            shouldTileBubbleBeVisible: shouldBeVisible,
            tileBubbleMediaItem: shouldBeVisible ? mediaItem : this.state.tileBubbleMediaItem,
            tileBubbleMediaItemTileNode: shouldBeVisible ? tileNode : this.state.tileBubbleMediaItemTileNode
        });
    };
}
